import React from 'react'
import { Popover, Tag } from 'antd'
import { LockOutlined } from '@ant-design/icons'

const isDebug = process.env.REACT_APP_PERMISSIONS_DEBUG === 'true'

const DebugPopoverTitle = props => {
  const { authorized } = props
  const color = authorized ? 'green' : 'red'

  return <span style={{ color, fontWeight: 'bold' }}>{authorized ? 'Authorized' : 'Not authorized'}</span>
}

const DebugPopoverContent = props => {
  const { permissions, roles } = props

  return (
    <>
      {roles && (
        <div>
          <b>Roles:</b>{' '}
          {roles.map(role => (
            <Tag key={role} style={{ marginBottom: '.25rem' }}>
              {role}
            </Tag>
          ))}
        </div>
      )}
      {permissions && (
        <div>
          <b>Permissions:</b>{' '}
          {permissions.map(perm => (
            <Tag key={perm} style={{ marginBottom: '.25rem' }}>
              {perm}
            </Tag>
          ))}
        </div>
      )}
    </>
  )
}

const DebugLock = props => {
  const { authorized, ...rest } = props

  const color = authorized ? 'green' : 'red'

  return (
    <LockOutlined
      {...rest}
      style={{
        color,
        background: 'white',
        borderRadius: '5px',
        padding: '2px',
        marginLeft: '4px',
      }}
    />
  )
}

const DebugPopover = props => {
  if (!isDebug) return null

  const { authorized, roles, permissions } = props

  return (
    <Popover title={<DebugPopoverTitle authorized={authorized} />} content={<DebugPopoverContent permissions={permissions} roles={roles} />}>
      <DebugLock authorized={authorized} />
    </Popover>
  )
}

export default DebugPopover
